import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import StickyPaperTableContainer from "component/sticky/StickyPaperTableContainer";
import t from "module/translations";
import { EntityIdentifier } from "module/entity/types";
import ButtonsContainer from "component/button/ButtonsContainer";
import ElementWithConfirmation from "component/elementWithConfirmation/ElementWithConfirmation";
import SignButton from "component/button/SignButton";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import TrainingCustomAssigneeTableHead from "module/trainingCustomAssignee/enrichedComponent/tableHead/TrainingCustomAssigneeTableHead";
import TrainingCustomAssigneeContextProvider from "module/trainingCustomAssignee/context/TrainingCustomAssigneeContextProvider";
import TrainingCustomAssigneeTableRowContainer from "module/trainingCustomAssignee/enrichedComponent/tableRow/TrainingCustomAssigneeTableRowContainer";

interface Props {
  assigneeIdentifiers: EntityIdentifier[];
  sign: () => Promise<void>;
}

const TrainingCustomToBeSignedDetailsAssignees: React.FC<Props> = ({
  assigneeIdentifiers,
  sign,
}) => {
  return (
    <>
      <StickyPaperTableContainer>
        <Table stickyHeader>
          <TrainingCustomAssigneeTableHead />
          <TableBody>
            {assigneeIdentifiers.map((assigneeIdentifier) => (
              <TrainingCustomAssigneeContextProvider
                {...{
                  entityIdentifier: assigneeIdentifier,
                  key: getEntityIdentifierKey(assigneeIdentifier),
                }}
              >
                <TrainingCustomAssigneeTableRowContainer />
              </TrainingCustomAssigneeContextProvider>
            ))}
          </TableBody>
        </Table>
      </StickyPaperTableContainer>
      <ButtonsContainer>
        <ElementWithConfirmation
          {...{
            confirmationDialogTitle:
              t.competencyManagement.signConfirmationText,
            asyncAction: sign,
          }}
        >
          {(props: { onClick: () => void }) => (
            <SignButton {...{ onClick: props.onClick }} />
          )}
        </ElementWithConfirmation>
      </ButtonsContainer>
    </>
  );
};

export default React.memo(TrainingCustomToBeSignedDetailsAssignees);
